import React, {useState} from "react";
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import {Card} from "primereact/card";
import "./Login.css";
import {useFormik} from "formik";
import {useIntl} from "react-intl";
import {LoginFormData, LoginResponse} from "../../lib/types/types";
import {Password} from "primereact/password";
import {classNames} from "primereact/utils";
import {AuthService} from "../../lib/services/auth-service";
import {useUserInfo} from "../../lib/hooks/useUserInfo";
import {validationSchema} from "./validation";
import {IconField} from "primereact/iconfield";
import {InputIcon} from "primereact/inputicon";
import {FloatLabel} from "primereact/floatlabel";

interface Props {
}

export const Login = (props: Props) => {
    const authService = new AuthService();
    const {formatMessage: f} = useIntl();

    const [log, setLog] = useState("");

    const {updateUserInfo} = useUserInfo();

    const initialValues: LoginFormData = {
        username: "",
        password: ""
    }


    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: (values: LoginFormData) => {
            // setFormData(values)
            authService.login(values.username, values.password).then((response: LoginResponse) => {
                updateUserInfo({
                    authenticated: true,
                    roles: response.roles,
                    userId: response.userId,
                    username: response.username
                });
            })
        }
    });

    const isFormFieldValid = (name: keyof LoginFormData): boolean => !!(formik.touched[name] && formik.errors[name]);

    const getFormErrorMessage = (name: keyof LoginFormData) => {
        return isFormFieldValid(name) &&
            <small className="p-error" style={{float: "left"}}>{formik.errors[name]}</small>;
    };

    // const manageNotificationPermission = () => {
    //     let tempText = "";
    //     if (!("Notification" in window)) {
    //         // Check if the browser supports notifications
    //         console.warn("This browser does not support desktop notification");
    //         tempText += "Notification is present!";
    //     } else if (Notification.permission === "granted") {
    //         // Check whether notification permissions have already been granted;
    //         // if so, create a notification
    //         // const notification = new Notification("Hi there!");
    //         console.log('Notification permission is granted')
    //         tempText += "\n Notification is already granted"
    //         // …
    //     } else if (Notification.permission !== "denied") {
    //         tempText += "\n Notification is default. Trying to request";
    //         // We need to ask the user for permission
    //         Notification.requestPermission().then((permission) => {
    //             // If the user accepts, let's create a notification
    //             if (permission === "granted") {
    //                 console.log('Notification permission is granted successfully')
    //                 tempText += "\n Permission granted";
    //                 // …
    //             } else {
    //                 console.log('Notification permission is blocked')
    //                 tempText += "\n Permission blocked";
    //             }
    //             setLog(prevState => tempText);
    //         });
    //         setLog(tempText);
    //     }
    //
    //     // At last, if the user has denied notifications, and you
    //     // want to be respectful there is no need to bother them anymore.
    // }

    return (
        <>
            <div className={`loginWrapper col-12`}>
                {/*<Button onClick={manageNotificationPermission} label={"request notification permissions"}/>*/}
                {/*<h2>{log}</h2>*/}
                <Card
                    className={`loginCardWrapper col-10 p-sm-8 md:col-6 lg:col-4 xl:col-3`}
                    title="EcoPetrol"
                    style={{textAlign: "center"}}
                >

                    <form onSubmit={formik.handleSubmit} className="p-fluid">

                        <div className="p-field mt-4 ">
                            <FloatLabel>
                                <IconField iconPosition={'left'}>
                                    <InputIcon className={'fas fa-user'}/>
                                    <InputText id="" name="username" autoComplete={"username"}
                                               value={formik.values.username} onChange={formik.handleChange} autoFocus
                                               className={classNames({'p-error': isFormFieldValid('username')})}/>
                                </IconField>
                                <label htmlFor="username"
                                       className={'ml-4' + classNames({'p-error': isFormFieldValid('username')})}>{f({id: "userName"})}</label>
                            </FloatLabel>
                            {getFormErrorMessage('username')}
                        </div>
                        <div className="p-field mt-6">
                            <span className="p-float-label">
                                <Password feedback={false} autoComplete={"current-password"} toggleMask id="password"
                                          name="password" value={formik.values.password} onChange={formik.handleChange}
                                          className={classNames({'p-error': isFormFieldValid('password')})}/>
                                <label htmlFor="password"
                                       className={classNames({'p-error': isFormFieldValid('password')})}>{f({id: "password"})}</label>
                            </span>
                            {getFormErrorMessage('password')}
                        </div>

                        <Button
                            className={'mt-4'}
                            label={f({id: "login"})}
                            type={"submit"}
                            style={{marginTop: "10px"}}
                            iconPos="right"
                            icon="fas fa-sign-in-alt"
                        />
                    </form>
                </Card>
            </div>
        </>
    );
};
